import { push } from 'redux-first-history';
import { getAlertMessageFunction } from '../../common/Util';
import { logout } from '../../features/login/loginSlice';
import axios from 'axios';

let lastAlertTime = 0;

const errorHandlingMiddleware = store => next => action => {
  if (action.type.endsWith('/rejected')) {
    const alertMessage = getAlertMessageFunction();
    const { error, payload } = action;

    console.log('action >>>');

    // axios의 요청 취소 에러인 경우 처리하지 않음
    if (axios.isCancel(error)) {
      console.log('Request canceled:', error.message);
      return next(action);
    }

    const currentTime = Date.now();
    // 연말정산 코드는 좀 다르다 그때그때 수정하자!

    let errorMessage = error?.message || '에러가 발생했습니다.';
    if (error?.response?.status === 401 || error?.message.endsWith('401')) {
      errorMessage = '접속 시간이 종료되었습니다. 다시 접속해주세요.';
      store.dispatch(logout());
      sStorage.clear();
    } else if (error?.message === 'Network Error') {
      errorMessage = '응답이 지연되고 있습니다. 잠시 후에 다시 시도해주세요.';
    }

    if (currentTime - lastAlertTime > 1000) {
      alertMessage(errorMessage, 'error');
      lastAlertTime = currentTime;
    }
  }
  // }
  return next(action);
};

export default errorHandlingMiddleware;
